import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseRequestMID } from "../utils/Classes/Requests/BaseRequestMID";
import { config } from "../utils/Constants";
import axios from "axios";
import {BaseRequest} from "../utils/Classes/Requests/BaseRequest";
import {fetchEmployeesAvatars} from "./employeesSlice";

const initialState = {
    employees: [],
    employeesAvatars: [],
    positions: [],
    oldPositions: [],
    loading: "idle",
    avatarLoading: "idle",
    successMessage: "",
    error: null,
    avatarError: null
};

const URL = config.url;

export const fetchLegalEmployees = createAsyncThunk(
    "LegalEmployee/GetLegalEntityEmployees",
    async () => {
        const req = new BaseRequest(
            sessionStorage.getItem("SessionID"),
        );
        const res = await axios.post(
            `${URL}/v1/LegalEmployee/GetLegalEntityEmployees`,
            req,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            }
        );
        return res.data;
    }
);

export const fetchLegalEmployeesAvatars = createAsyncThunk(
    "Employees/GetEmployeesAvatars",
    async () => {
        const req = new BaseRequest(
            sessionStorage.getItem("SessionID")
        );
        const res = await axios.post(
            `${URL}/v1/LegalEmployee/GetEmployeesAvatars`,
            req,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: sessionStorage.getItem("Token"),
                }
            }
        );
        return res.data;
    });

const legalEmployeesSlice = createSlice({
    name: "employees",
    initialState,
    reducers: {
        // TODO: Reducers for employees UI, such as edit or delete
        addLegalEmployee: (state, action) => {
            state.employees = [...state.employees, action.payload];
        },
        setLegalEmployeesError: (state, action) => {
            state.error = action.payload;
        },
        setSuccessMessage: (state, action) => {
            state.successMessage = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchLegalEmployees.pending, (state) => {
            if (state.loading === "idle") {
                state.loading = "pending";
            }
        });
        builder.addCase(fetchLegalEmployees.fulfilled, (state, action) => {
            if (state.loading === "pending") {
                state.loading = "idle";
                state.employees = [...action.payload.Payload.Employees];
                state.positions = [...action.payload.Payload.Positions];
            }
        });
        builder.addCase(fetchLegalEmployees.rejected, (state, action) => {
            if (state.loading === "pending") {
                state.loading = "idle";
                state.employees = [];
                state.positions = [];
                state.oldPositions = [];
                state.error = action.error;
            }
        });

        //legal employees avatars
        builder.addCase(fetchLegalEmployeesAvatars.pending, (state) => {
            if (state.avatarLoading === "idle") {
                state.avatarLoading = "pending";
            }
        });
        builder.addCase(fetchLegalEmployeesAvatars.fulfilled, (state, action) => {
            if (state.avatarLoading === "pending") {
                state.avatarLoading = "idle";
                state.employeesAvatars = [...action.payload.Payload.EmployeeAvatars];
            }
        });
        builder.addCase(fetchLegalEmployeesAvatars.rejected, (state, action) => {
            if (state.avatarLoading === "pending") {
                state.avatarLoading = "idle";
                state.avatarError = action.error;
            }
        });
    },
});

export const { setLegalEmployeesError, setLoading } = legalEmployeesSlice.actions;

export default legalEmployeesSlice.reducer;
